var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flex',{staticClass:"layout center-mobile",style:({ background: _vm.background }),attrs:{"root":"","align":"center"}},[_c('cell',_vm._b({},'cell',Object.assign({ grow: 0, basis: 'auto' }, _vm.$attrs),false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }